import {
  AdaptiveDpr,
  PresentationControls,
  useAnimations,
} from "@react-three/drei";
import { Canvas } from "@react-three/fiber";
import React, { Suspense, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import TochiChicken from "src/components/TochiChicken";
import TochiItem from "src/components/TochiItem";
import { getAnimClips } from "src/utils/redux/tochiAnimation";
import { getAssets } from "src/utils/redux/tochiAsset";
import { getChicken } from "src/utils/redux/tochiChicken";
import { AnimationObjectGroup } from "three";

type Props = {
  version: string;
};

export default function ChickenScreen({ version }: Props) {
  const assets = useSelector(getAssets);
  const chicken = useSelector(getChicken);
  const clips = useSelector(getAnimClips);

  const animGroup = useRef(new AnimationObjectGroup());

  const AnimController = () => {
    const { actions } = useAnimations(clips, animGroup as any);
    useEffect(() => {
      actions["idle"]?.play();
      actions["idle"]?.setDuration(0);
    }, []);
    return null;
  };

  return (
    <Canvas style={{ height: "100vh" }}>
      <ambientLight />
      <pointLight position={[10, 10, 10]} />
      <PresentationControls
        global
        config={{ mass: 2, tension: 200 }}
        snap={false}
        rotation={[0, -Math.PI / 15, 0]}
        polar={[-Math.PI / 3, Math.PI / 3]}
      >
        <group position={[0, -1, 0]}>
          <Suspense fallback={null}>
            <group scale={80} dispose={null}>
              {chicken && assets ? (
                <>
                  <TochiChicken
                    asset={assets.chicken}
                    chicken={chicken}
                    items={chicken.items}
                    animGroup={animGroup.current}
                    eye={"Default"}
                    disableBlinking
                  />
                </>
              ) : null}
              {(chicken?.items || []).map((item) => (
                <TochiItem
                  item={item}
                  animGroup={animGroup.current}
                  key={item._id}
                />
              ))}
              <AnimController />
            </group>
          </Suspense>
        </group>
      </PresentationControls>
      <AdaptiveDpr pixelated />
    </Canvas>
  );
}
